import { Component } from '@angular/core';
import { StatsWidget } from './components/statswidget';

import { SharedModule } from '@shared/shared.module';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';
import { TopProfitablesWidget } from './components/topprofitableswidget';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DailySummaryWidget } from './components/dailysummarywidget';
import { LatestSalesWidgetComponent } from './components/latest-sales-widget.component';
import { LatestPriceSyncWidgetComponent } from './components/latest-price-sync-widget.component';
import { TopSellablesWidget } from './components/topsellableswidget';
import { TabViewModule } from 'primeng/tabview';
import { QuadrantPerformanceMatrixComponent } from './components/quadrant-performance-matrix/quadrant-performance-matrix.component';
import { PurchaseHistoryStatComponent } from './components/purchase-history-stat/purchase-history-stat.component';

@Component({
    selector: 'app-dashboard',
    //standalone: false,
    imports: [StatsWidget, 
        TopProfitablesWidget, 
        TopSellablesWidget,
        QuadrantPerformanceMatrixComponent,
        PurchaseHistoryStatComponent,
        DailySummaryWidget,
        LatestSalesWidgetComponent,
        LatestPriceSyncWidgetComponent,
        MessageModule ,
        SharedModule,
        CommonModule,
        CheckboxModule,
        FormsModule,
        TabViewModule],
    templateUrl:"./dashboard.html",
    styles: [`
        ::ng-deep .p-tabpanels {
            background: transparent !important;
        }
        ::ng-deep .p-tabview .p-tabview-panels {
            background: transparent !important;
            padding: 0 !important;
        }
        ::ng-deep .p-tabview .p-tabview-panel {
            background: transparent !important;
        }
    `]
    // template: `
    //     <div class="grid grid-cols-12 gap-8">
    //         <app-stats-widget class="contents" />
    //         <div class="col-span-12 xl:col-span-6">
    //             <app-recent-sales-widget />
    //             <app-best-selling-widget />
    //         </div>
    //         <div class="col-span-12 xl:col-span-6">
    //             <app-revenue-stream-widget />
    //             <app-notifications-widget />
    //         </div>
    //     </div>
    // `
})

export class Dashboard {
    showDummyData:boolean=false;
    showIntergrationTip:boolean=false;

    activeTabIndex: number = 0;
    dateStart!: Date;
    dateEnd!: Date;
    panelHeader: string = "Today's Performance";

    todayStart!: Date;
    todayEnd!: Date;
    yesterdayStart!: Date;
    yesterdayEnd!: Date;
    last7DaysStart!: Date;
    last7DaysEnd!: Date;

    ngOnInit() {
        // Today
        this.todayStart = new Date(new Date().toDateString());
        this.todayEnd = new Date(this.todayStart.getTime() + (1000 * 60 * 60 * 24));
        
        // Yesterday
        this.yesterdayStart = new Date(this.todayStart.getTime() - (1000 * 60 * 60 * 24));
        this.yesterdayEnd = this.todayStart;
        
        // Last 7 days
        this.last7DaysStart = new Date(this.todayStart.getTime() - (7 * 1000 * 60 * 60 * 24));
        this.last7DaysEnd = this.todayEnd;

        // Initialize with today's dates
        this.setDatesByTab(0);
    }

    onTabChange(index: number) {
        this.setDatesByTab(index);
    }

    setDatesByTab(tabIndex: number) {
        switch (tabIndex) {
            case 0:
                this.dateStart = this.todayStart;
                this.dateEnd = this.todayEnd;
                break;
            case 1:
                this.dateStart = this.yesterdayStart;
                this.dateEnd = this.yesterdayEnd;
                break;
            case 2:
                this.dateStart = this.last7DaysStart;
                this.dateEnd = this.last7DaysEnd;
                break;
        }
    }
}
